var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.1 12.47a4.38 4.38 0 0 1 4.37-4.38h12c1.19 0 2.33.49 3.16 1.35l4.4 4.6c.78.82 1.22 1.9 1.22 3.03v5.8a10.35 10.35 0 0 0-2.19.13v-5.93c0-.57-.21-1.1-.6-1.52l-4.41-4.6a2.19 2.19 0 0 0-1.58-.67h-12c-1.21 0-2.19.98-2.19 2.19v6.7a4.38 4.38 0 0 1 0 8.47v6.7c0 1.21.98 2.2 2.19 2.2h11.16c.33.78.77 1.51 1.28 2.18H14.47a4.38 4.38 0 0 1-4.38-4.38V26.7c0-.6.5-1.1 1.1-1.1a2.19 2.19 0 1 0 0-4.37 1.1 1.1 0 0 1-1.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.2 13.02a1.1 1.1 0 1 0-2.18 0v4.37a1.1 1.1 0 1 0 2.18 0zM21.58 13.02a1.1 1.1 0 1 0-2.19 0v4.37a1.1 1.1 0 1 0 2.19 0zM24.86 11.92c.6 0 1.1.5 1.1 1.1v4.37a1.1 1.1 0 1 1-2.2 0v-4.37c0-.6.5-1.1 1.1-1.1zM30.33 16.3a1.1 1.1 0 1 0-2.19 0v1.09a1.1 1.1 0 1 0 2.19 0zM30.33 32.7c0-.6.49-1.09 1.1-1.09h2.18v-2.19a1.1 1.1 0 1 1 2.19 0v2.19h2.18a1.1 1.1 0 1 1 0 2.19H35.8v2.18a1.1 1.1 0 1 1-2.19 0V33.8h-2.19c-.6 0-1.1-.5-1.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.9 32.7a8.2 8.2 0 1 0-16.4 0 8.2 8.2 0 0 0 16.4 0zm-8.2-6.01a6.02 6.02 0 1 1 0 12.03 6.02 6.02 0 0 1 0-12.03z",
    fillRule: "evenodd"
  })));
});